import { func, string } from 'prop-types'
import FontAwesome from 'react-fontawesome'

import styles from './Total.scss'


Total.propTypes = {
    onClick: func.isRequired,
    totalPrice: string.isRequired
}

function Total({ totalPrice, onClick }) {
    return (
        <ul className={styles.right}>
            <li>
                <div>Total:&nbsp;</div>

                <a href="javascript:void(0);" id="cart" onClick={onClick} className={styles.sum}><FontAwesome name='caret-down'/>
                    &nbsp;{totalPrice}
                </a>
            </li>
        </ul>
    )
}

export default Total


// WEBPACK FOOTER //
// ./app/components/Total.js